import React, { useEffect, useRef } from 'react';

/**
 * Auto-submits a hidden POST form to redirect the user to the Paynkolay
 * hosted VPOS checkout page (full-page redirect, not iframe).
 *
 * Accepts a flat `paymentData` object (the raw backend response).
 * Extracts `actionUrl` directly from the root level.
 * All remaining fields are rendered as hidden inputs.
 */
export default function PaynkolayIframeForm({ paymentData }) {
  const formRef = useRef(null);

  // Extract actionUrl from the flat paymentData object
  const actionUrl = paymentData?.actionUrl;

  // Build formFields: all keys except actionUrl
  const formFields = { ...(paymentData || {}) };
  delete formFields?.actionUrl;

  useEffect(() => {
    if (!actionUrl) {
      console.error('Paynkolay redirection aborted: actionUrl is missing!');
      return;
    }
    if (formRef?.current) {
      formRef?.current?.submit();
    }
  }, [actionUrl]);

  // Guard: do not render or auto-submit if actionUrl is missing
  if (!actionUrl) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
        <div className="text-center px-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p className="text-lg font-semibold text-red-600 mb-2">Ödeme sayfasına yönlendirilemiyor</p>
          <p className="text-sm text-gray-500">Parametreler eksik. Lütfen geri dönüp tekrar deneyin.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
      {/* Hidden POST form — auto-submitted on mount */}
      <form
        ref={formRef}
        action={actionUrl}
        method="POST"
        target="_blank"
        style={{ display: 'none' }}
      >
        {Object.entries(formFields)?.map(([key, value]) => (
          <input key={key} type="hidden" name={key} value={String(value ?? '')} />
        ))}
      </form>
      {/* Loading indicator shown while redirect is in progress */}
      <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-6" />
      <p className="text-lg font-medium text-gray-700 text-center px-4">
        Güvenli ödeme sayfasına yönlendiriliyorsunuz, lütfen bekleyin...
      </p>
      <p className="text-sm text-gray-400 mt-2">Lütfen sayfayı kapatmayın.</p>
    </div>
  );
}
